import React from'react';
import { Link, useLocation } from'react-router-dom';
import { ChevronRight, Home } from'lucide-react';

const ROUTE_LABELS = {
'/':'Dashboard',
'/products':'Products',
'/apis':'API Analytics',
'/realtime':'Real-Time',
'/conversations':'Conversations',
'/costs':'Cost Center',
'/users':'Users',
'/settings':'Settings',
'/traffic-controls':'Traffic Controls',
};

/**
 * Auto-generates breadcrumbs from the current route path.
 * Supports dynamic segments like /products/:id
 */
export default function Breadcrumbs({ items }) {
 const location = useLocation();

 // If explicit items are provided, use those
 if (items && items.length > 0) {
 return (
 <nav className="flex items-center gap-1 text-xs text-gray-500 mb-3">
 <Link to="/" className="hover:text-brand-600 transition">
 <Home className="w-3.5 h-3.5" />
 </Link>
 {items.map((item, idx) => (
 <React.Fragment key={idx}>
 <ChevronRight className="w-3 h-3 text-gray-300" />
 {item.href ? (
 <Link to={item.href} className="hover:text-brand-600 transition">
 {item.label}
 </Link>
 ) : (
 <span className="text-gray-700 font-medium">{item.label}</span>
 )}
 </React.Fragment>
 ))}
 </nav>
 );
 }

 // Auto-generate from URL
 const pathSegments = location.pathname.split('/').filter(Boolean);
 const crumbs = [];

 pathSegments.forEach((seg, idx) => {
 const path ='/' + pathSegments.slice(0, idx + 1).join('/');
 const label = ROUTE_LABELS[path] || decodeURIComponent(seg);
 const isLast = idx === pathSegments.length - 1;
 crumbs.push({ label, href: isLast ? null : path });
 });

 if (crumbs.length === 0) return null;

 return (
 <nav className="flex items-center gap-1 text-xs text-gray-500 mb-3">
 <Link to="/" className="hover:text-brand-600 transition">
 <Home className="w-3.5 h-3.5" />
 </Link>
 {crumbs.map((crumb, idx) => (
 <React.Fragment key={idx}>
 <ChevronRight className="w-3 h-3 text-gray-300" />
 {crumb.href ? (
 <Link to={crumb.href} className="hover:text-brand-600 transition">
 {crumb.label}
 </Link>
 ) : (
 <span className="text-gray-700 font-medium">{crumb.label}</span>
 )}
 </React.Fragment>
 ))}
 </nav>
 );
}
